import { Flex } from '@/layouts/Flex';

import { Button } from '@/components/Button';
import { Colors } from '@/plugins/data/colors';
import styles from './styles.module.scss';

export function Footer() {
  return (
    <Flex justifyContent='space-between' alignItems='center' className={styles.footer}>
      <Flex flexDirection='row' gap={32}>
        <Flex flexDirection='column' gap={4}>
          <Button to='/legal' variant='simple' textColor={Colors.light}>
            Aviso legal
          </Button>
          <Button to='/privacy-policy' variant='simple' textColor={Colors.light}>
            Política de privacidad
          </Button>
        </Flex>
        <Flex flexDirection='column' gap={4}>
          <Button to='/cookies-policy' variant='simple' textColor={Colors.light}>
            Política de cookies
          </Button>
          <Button to='/terms-and-conditions' variant='simple' textColor={Colors.light}>
            Términos y condiciones
          </Button>
        </Flex>
      </Flex>
      <p className={styles.rights}>© {new Date().getFullYear()}. Todos los derechos reservados.</p>
    </Flex>
  );
}
